import React from 'react';
import styled from 'styled-components';
import {defaultTheme} from '@stencil/build-theme';
import {
  FlexCentered,
  ButtonBase,
} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const BookingWidgetStyleContainer = styled.div(
  props => `
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  padding:${props.theme.spacing.custom(8)};
  background-color:${props.theme.colors.goZest.light};
`,
);

export const PriceStartsAtText = styled.p(
  props => `
  color:${props.theme.colors.downriver.medium};
  padding: 0 ${props.theme.spacing.base};
`,
);

export const PriceInfo = styled.div(
  props => `
  display: flex;
  height:7rem;
  padding: 0 ${props.theme.spacing.base};
`,
);

export const Column = styled.div(
  props => `
  width: 50%;
`,
);

export const PriceValueStyled = styled.p(
  props => `
  display: inline-flex;
  font-size:${props.theme.font.custom(22)};
  font-weight:bold;
  font-family:${props.theme.font.fontFamily};
`,
);

export const PriceValue: React.FC<{price?: number}> = ({price}) => (
  <PriceValueStyled>{price}</PriceValueStyled>
);

export const plusPriceRupeeIconProps = {
  fill: defaultTheme.colors.downriver.base,
  width: '0.8rem',
  height: '0.8rem',
};

export const PlusPriceValueText = styled.p(
  props => `
  display: inline-flex;
  font-size:${props.theme.font.small};
`,
);

export const PlusPriceValue: React.FC<{price: number}> = ({price}) => (
  <PlusPriceValueText>{price} taxes & fees</PlusPriceValueText>
);

export const PerRoomPerNightLabel = styled.p(
  props => `
  display: inline-flex;
  color:${props.theme.colors.downriver.medium};
`,
);

export const NoOfGuestsContainer = styled(FlexCentered)(
  props => `
  padding: 0 0 ${props.theme.spacing.small} 0
`,
);

export const NoOfRoomsContainer = NoOfGuestsContainer;

export const NoOfGuestsAndRoomsTextStyles = styled.p(
  props => `
  font-weight:bold;
  font-size:${props.theme.font.custom(14)};
  padding: 0 0 0 ${props.theme.spacing.base}
`,
);

export const RightDoubleArrowIconContainer = styled.div`
  transform: rotate(90deg) translateX(8px);
  display: inline-block;
  position: relative;
  top: -0.5rem;
  left: 0.5rem;
`;

export const ViewRoomOptionsButton = styled(ButtonBase)(
  props => `
  padding: ${props.theme.spacing.small} ${props.theme.spacing.large} ${props.theme.spacing.base};
  height:4.7rem;
  width:100%;
  font-family: inherit;
`,
);
